<div class="cut-container" #cutContainer
    [ngClass]="{ 'invisible': !showCutContainer }"
    [style.height.px]="cutContainerHeight"
    [style.width.px]="cutContainerWidth" 
    [style.left]="cutContainerLeft">

    <div class="selection-marquee" *ngIf="selection.height > 0 || selection.width > 0"
        [style.top.px]="selection.top" 
        [style.left.px]="selection.left"
        [style.width.px]="selection.width" 
        [style.height.px]="selection.height">
    </div>

</div>

<div class="outer-cut-container loader"
    [ngClass]="{ 'invisible': !showLoader }"
    [style.height.px]="cutContainerHeight"
    [style.width.px]="cutContainerWidth" 
    [style.left]="cutContainerLeft">
</div>